<template>
  <div class="dyk-root">

    <!-- LOADER -->
    <div class="dyk-loader" v-if="loading">
      <div class="dyk-shimmer-wrap">
        <div class="dyk-shimmer dyk-shimmer--card"></div>
        <div class="dyk-shimmer-rows">
          <div class="dyk-shimmer dyk-shimmer--row dyk-shimmer--w90"></div>
          <div class="dyk-shimmer dyk-shimmer--row dyk-shimmer--w70"></div>
          <div class="dyk-shimmer dyk-shimmer--row dyk-shimmer--w80"></div>
          <div class="dyk-shimmer dyk-shimmer--row dyk-shimmer--w65"></div>
        </div>
      </div>
    </div>

    <!-- SPOTLIGHT CARD -->
    <div class="dyk-spotlight" v-else-if="GetData.length">
      <!-- bg decoration -->
      <div class="dyk-spot-orb dyk-spot-orb--1"></div>
      <div class="dyk-spot-orb dyk-spot-orb--2"></div>

      <div class="dyk-spot-top">
        <div class="dyk-spot-eyebrow">
          <v-icon size="11" color="rgba(255,255,255,0.6)">mdi-lightbulb-on-outline</v-icon>
          <span>Did You Know?</span>
        </div>
        <div class="dyk-spot-counter">{{ active + 1 }}/{{ GetData.length }}</div>
      </div>

      <p class="dyk-spot-text">{{ GetData[active].label }}</p>

      <div class="dyk-spot-nav">
        <button class="dyk-nav-btn" @click="prev" :disabled="active === 0">
          <v-icon size="13">mdi-chevron-left</v-icon>
        </button>
        <div class="dyk-dots">
          <span
            class="dyk-dot"
            v-for="(_, i) in GetData"
            :key="i"
            :class="{ 'dyk-dot--active': i === active }"
            @click="active = i"
          ></span>
        </div>
        <button class="dyk-nav-btn" @click="next" :disabled="active === GetData.length - 1">
          <v-icon size="13">mdi-chevron-right</v-icon>
        </button>
      </div>
    </div>

    <!-- LIST -->
    <div class="dyk-list" v-if="!loading && GetData.length">
      <div
        class="dyk-item"
        v-for="(item, i) in GetData"
        :key="i"
        :class="{ 'dyk-item--active': i === active }"
        :style="{ '--i': i }"
        @click="active = i"
      >
        <span class="dyk-item__index">{{ String(i + 1).padStart(2, '0') }}</span>
        <span class="dyk-item__text">{{ item.label }}</span>
        <!-- <v-icon size="11" class="dyk-item__arrow">mdi-chevron-right</v-icon> -->
      </div>
    </div>

    <!-- EMPTY -->
    <div class="dyk-empty" v-if="!loading && !GetData.length">
      <div class="dyk-empty__icon">
        <v-icon size="26" color="#3C5AAA">mdi-lightbulb-outline</v-icon>
      </div>
      <span class="dyk-empty__title">No insights yet</span>
      <span class="dyk-empty__sub">Check back soon</span>
    </div>

  </div>
</template>

<script>
import DashboardService from "@/api/service/Dashboard/DashboardService.js";
export default {
  props: ["userId"],
  data() {
    return {
      GetData: [],
      active: 0,
      loading: false,
      autoTimer: null,
    };
  },
  watch: {
    userId(val) { if (val) this.getinsights(val); },
  },
  created() {
    this.getinsights(this.userId);
  },
  beforeUnmount() {
    clearInterval(this.autoTimer);
  },
  methods: {
    async getinsights(id) {
      this.loading = true;
      try {
        const res = await DashboardService.insights({ userId: id });
        this.GetData = res || [];
        this.active = 0;
        this.startAuto();
      } finally {
        this.loading = false;
      }
    },
    next() { if (this.active < this.GetData.length - 1) this.active++; else this.active = 0; },
    prev() { if (this.active > 0) this.active--; },
    startAuto() {
      clearInterval(this.autoTimer);
      if (this.GetData.length > 1) {
        this.autoTimer = setInterval(() => { this.next(); }, 6000);
      }
    },
  },
};
</script>

<style scoped>
/* ── Root ── */
.dyk-root {
  height: 100%;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e9edf2;
  box-shadow: 0 2px 12px rgba(60, 90, 170, 0.06);
  display: flex;
  flex-direction: column;
  padding: 12px 12px 10px;
  gap: 8px;
  overflow: hidden;
}

/* ── Spotlight card ── */
.dyk-spotlight {
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e2d4a 0%, #0f1f3d 60%, #162240 100%);
  padding: 14px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Glow orbs */
.dyk-spot-orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(40px);
}
.dyk-spot-orb--1 {
  width: 110px; height: 110px;
  top: -30px; right: -20px;
  background: rgba(60, 90, 170, 0.45);
}
.dyk-spot-orb--2 {
  width: 80px; height: 80px;
  bottom: -25px; left: -15px;
  background: rgba(99, 132, 220, 0.3);
}

/* Top row */
.dyk-spot-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.dyk-spot-eyebrow {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: rgba(255, 255, 255, 0.45);
}

.dyk-spot-counter {
  font-size: 9px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.3);
  letter-spacing: 0.5px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 20px;
  padding: 1px 8px;
}

/* Text */
.dyk-spot-text {
  font-size: 12px;
  font-weight: 600;
  color: #e8eeff;
  line-height: 1.65;
  margin: 0;
  position: relative;
  z-index: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Nav */
.dyk-spot-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 1;
}

.dyk-nav-btn {
  width: 22px; height: 22px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.15s;
  flex-shrink: 0;
}
.dyk-nav-btn:hover:not(:disabled) {
  background: rgba(60, 90, 170, 0.35);
  border-color: rgba(99, 132, 220, 0.5);
  color: #a5b8f0;
}
.dyk-nav-btn:disabled { opacity: 0.25; cursor: default; }

.dyk-dots { display: flex; gap: 4px; flex: 1; justify-content: center; }
.dyk-dot {
  width: 5px; height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  cursor: pointer;
  transition: all 0.2s ease;
}
.dyk-dot--active {
  background: #6384dc;
  width: 16px;
  border-radius: 3px;
  box-shadow: 0 0 6px rgba(99, 132, 220, 0.6);
}

/* ── List ── */
.dyk-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  overflow-y: auto;
  flex: 1;
}
.dyk-list::-webkit-scrollbar { width: 3px; }
.dyk-list::-webkit-scrollbar-thumb { background: rgba(60,90,170,0.15); border-radius: 3px; }

.dyk-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  border-left: 2px solid transparent;
  background: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  animation: dykIn 0.2s ease both;
  animation-delay: calc(var(--i) * 0.04s);
}
.dyk-item:hover {
  background: rgba(60, 90, 170, 0.05);
  border-color: rgba(60, 90, 170, 0.1);
  border-left-color: rgba(60, 90, 170, 0.4);
}
.dyk-item--active {
  background: rgba(60, 90, 170, 0.07);
  border-color: rgba(60, 90, 170, 0.15);
  border-left-color: #3C5AAA;
}

@keyframes dykIn {
  from { opacity: 0; transform: translateX(-4px); }
  to   { opacity: 1; transform: translateX(0); }
}

.dyk-item__index {
  font-size: 9px;
  font-weight: 800;
  color: #c8d4ee;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
  width: 18px;
}
.dyk-item--active .dyk-item__index { color: #3C5AAA; }

.dyk-item__text {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  flex: 1;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dyk-item--active .dyk-item__text { color: #1e293b; font-weight: 600; }

.dyk-item__arrow {
  color: #e2e8f0 !important;
  flex-shrink: 0;
  transition: color 0.15s, transform 0.15s;
}
.dyk-item:hover .dyk-item__arrow,
.dyk-item--active .dyk-item__arrow {
  color: #3C5AAA !important;
  transform: translateX(2px);
}

/* ── Empty ── */
.dyk-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.dyk-empty__icon {
  width: 48px; height: 48px;
  border-radius: 14px;
  background: rgba(60, 90, 170, 0.07);
  border: 1px solid rgba(60, 90, 170, 0.15);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 4px;
}
.dyk-empty__title { font-size: 12px; font-weight: 700; color: #334155; }
.dyk-empty__sub   { font-size: 10px; color: #94a3b8; }

/* ── Loader ── */
.dyk-loader {
  flex: 1;
  display: flex;
  align-items: flex-start;
  padding: 4px 0;
}
.dyk-shimmer-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dyk-shimmer {
  border-radius: 8px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e8edf5 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: dyk-shimmer-move 1.4s ease-in-out infinite;
}
.dyk-shimmer--card   { height: 110px; width: 100%; border-radius: 12px; }
.dyk-shimmer-rows    { display: flex; flex-direction: column; gap: 8px; }
.dyk-shimmer--row    { height: 13px; }
.dyk-shimmer--w90    { width: 90%; }
.dyk-shimmer--w70    { width: 70%; }
.dyk-shimmer--w80    { width: 80%; }
.dyk-shimmer--w65    { width: 65%; }
@keyframes dyk-shimmer-move {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
